import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isPartnerClalit,
  isPartnerMaoflaamit,
  isPartnerOvdimBari,
  selectIsMinor,
  selectPartner,
} from "../../../store/partnerStore";
import {
  checkCanPurchasePass,
  selectCanPurchaseChecked,
  selectCanPurchaseLoading,
  selectCanPurchaseNewPass,
} from "../../../store/multipleEntryPassSlice";
import usePassState, { PASS_STATE } from "../../hooks/usePassState";
import { getPartnerAsset } from "../../theme/partnerAssets";

// Data layer for the routed /profile screen (no V1 counterpart, so the data
// logic lives here per the v2 README convention). The pass state comes from
// the shared usePassState hook, which home also uses.
export default function useProfileData() {
  const dispatch = useDispatch();
  const partner = useSelector(selectPartner);
  const isMinor = useSelector(selectIsMinor);
  const userParams = useSelector((state) => state.userSlice.userData);
  const isHaveCreditCard = useSelector((state) => state.userSlice.isHaveCreditCard);
  const passState = usePassState();

  const token = useSelector((state) => state.userSlice.mainUserData?.Token);
  const id = useSelector((state) => state.userSlice.mainUserData?.ID);
  const phone = useSelector((state) => state.userSlice.mainUserData?.Phone);
  const canPurchaseNewPass = useSelector(selectCanPurchaseNewPass);
  const canPurchaseChecked = useSelector(selectCanPurchaseChecked);
  const canPurchaseLoading = useSelector(selectCanPurchaseLoading);
  const isClalit = useSelector(isPartnerClalit);
  const isOvdimBari = useSelector(isPartnerOvdimBari);
  const isMaoflaamit = useSelector(isPartnerMaoflaamit);

  // Self-heal for a direct URL hit / hard refresh, where home never ran the
  // purchase-eligibility check. Same guards as useHomeData; the thunk's
  // in-flight condition absorbs a duplicate dispatch.
  useEffect(() => {
    if (canPurchaseChecked || canPurchaseLoading) return;
    if (!(isClalit || isOvdimBari || isMaoflaamit)) return;
    if (!token || !id || !phone) return;
    dispatch(checkCanPurchasePass({ token, id, phone }));
  }, [token, id, phone, canPurchaseChecked, canPurchaseLoading, isClalit, isOvdimBari, isMaoflaamit, dispatch]);

  return {
    partner,
    firstName: userParams.FirstName,
    lastName: userParams.LastName,
    cardNumber: userParams.CardNumber,
    passState,
    // Same rule as HomePassBanner: no usable pass (never had one, or all
    // expired) and the server allows a purchase — strict === true so null
    // (answer not landed) also hides it.
    showPassPromo:
      (passState?.state === PASS_STATE.NONE || passState?.state === PASS_STATE.INACTIVE) &&
      canPurchaseNewPass === true,
    showPayment: !isMinor,
    paymentPath: isHaveCreditCard ? "/card-details" : "/addCard",
    passArt: getPartnerAsset(partner, "profilePassCardImg") ?? getPartnerAsset(partner, "passCardImg"),
  };
}
